"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _styles = require("@mui/styles");
var _Tooltip = _interopRequireDefault(require("../../Tooltip"));
var _Stack = _interopRequireDefault(require("../../Stack"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var useStyles = (0, _styles.makeStyles)({
  root: {
    cursor: 'pointer',
    pointerEvents: 'auto'
  }
});
var infoLabels = {
  errors: 'Error',
  warnings: 'Warning',
  hint: 'Hint'
};
var HintTooltip = function HintTooltip(_ref) {
  var children = _ref.children,
    info = _ref.info;
  var classes = useStyles();
  var infoNormalized = Object.keys(info).reduce(function (acc, key) {
    var value = info[key];
    if (Array.isArray(value) ? value.length : value) {
      return _objectSpread(_objectSpread({}, acc), {}, _defineProperty({}, key, value));
    }
    return acc;
  }, {});
  var infoList = Object.keys(infoNormalized);
  if (!infoList.length) {
    return null;
  }
  var renderInfoItem = function renderInfoItem(infoValue) {
    return Array.isArray(infoValue) ? infoValue.length > 1 ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_Stack["default"], {
      children: infoValue.map(function (item, i) {
        return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_Stack["default"], {
          children: ["".concat(i + 1, ". "), item]
        }, i);
      })
    }) : infoValue[0] : infoValue;
  };
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_Tooltip["default"], {
    className: classes.root,
    title: infoList.length > 1 ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_Stack["default"], {
      spacing: 1,
      children: infoList.map(function (infoName) {
        return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_Stack["default"], {
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("b", {
            children: infoLabels[infoName]
          }), renderInfoItem(infoNormalized[infoName])]
        }, infoName);
      })
    }) : renderInfoItem(infoNormalized[infoList[0]]),
    wrapperComponent: _Stack["default"],
    wrapper: true,
    children: children
  });
};
var _default = exports["default"] = HintTooltip;